import { h, defineComponent, PropType } from 'vue';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { start_adding_vertex, stop_adding_vertex } from '../../scene';
import { disabled } from '../../state/operations/add-vertex';
import { shift_pressed } from '../../keypress';
import { coming_soon } from '@components/icons';
import { img } from '@phi/components';
import add_vertex_svg from '../../../assets/img/SVG_icons/Top/create_model/add_vertex.svg';
import AddVertexTooltip from './AddVertexTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const AddVertexIcon = add_vertex_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Add Vertex';
        }
    },

    methods: {
        onClick() {
            if (disabled.value)
                return;
            else if (this.state.adding_vertex)
                stop_adding_vertex();
            else
                start_adding_vertex(shift_pressed());
        },
    },

    render() {
        return h(BarButton, {
            disabled: disabled.value,
            selected: this.state.tut_stage === 2,
            active: this.state.adding_vertex,
            id: 'add-vertex-button',
            wrapperId: 'add-vertex-wrapper',
            tippy: 'bottom',
            onClick: this.onClick,
            help: 'add_vertex',
        }, {
            label: () => '+Vertex',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(add_vertex_svg, this.alt),
            tooltip: AddVertexTooltip,
        });
    },
});
